import { Component, HostListener, inject } from '@angular/core';
import { NavigationService } from '../../services/shared/navigation.service';
import { Observable } from 'rxjs';

@Component({
    template: '',
    standalone: true
})
export abstract class PageBaseComponent {


    private readonly navigationService = inject(NavigationService);

    public get isNewRequest(): boolean {
        return this.navigationService.isNewRequest;
    }

    public get requestId(): string | null {
        return this.navigationService.requestGuid;
    }

    public readonly requestGuid$: Observable<string | null>;

    constructor() {
        this.requestGuid$ = this.navigationService.requestGuid$;
    }

    protected navigate(path: string): void {
        this.navigationService.navigate(path);
    }

    @HostListener('swipeleft')
    onSwipeLeft() {
        this.next();
    }

    @HostListener('swiperight')
    onSwipeRight() {
        this.back();
    }

    public abstract next(): void;
    public abstract back(): void;
}